import { render } from "./CxLanguagePicker.vue?vue&type=template&id=032b7df5&ts=true"
import script from "./CxLanguagePicker.vue?vue&type=script&lang=ts"
export * from "./CxLanguagePicker.vue?vue&type=script&lang=ts"

import "./CxLanguagePicker.vue?vue&type=style&index=0&id=032b7df5&lang=less"

import exportComponent from "C:\\hexagon_develop\\hexagon_develop\\conx-ui\\microfrontends\\conx-ui-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__